export function getBaseUrl() {
    const { protocol, host } = window.location; // host = hostname + :port (if any)
    return `${protocol}//${host}`;
}